import React from 'react';
import { useLocation } from 'react-router-dom';

import IdntyDownloadView, { USER_TYPE } from '../presentational/IdntyDownloadView';

const IdntyRegistrationConfirmationContainer = () => {
  const { search } = useLocation();
  // A missing or malformed param falls through to undefined, so
  // IdntyDownloadView's defaultProps resolves it to NEW_USER.
  const rawUserType = Number(new URLSearchParams(search).get('userType'));
  const userType = Object.values(USER_TYPE).includes(rawUserType) ? rawUserType : undefined;

  return (
    <IdntyDownloadView userType={userType} />
  );
};

export default IdntyRegistrationConfirmationContainer;
